import React from 'react';

/**
 * @param {Object} shiftInfo
 * @param {string} [shiftInfo.label]
 * @param {string} shiftInfo.timeString
 * @returns {JSX.Element}
 */
export const genShiftTooltipLabelAndTime = (shiftInfo) => {
    if (shiftInfo.label) {
        return (
            <>
                <div className="ShiftTooltipShiftLabel">{shiftInfo.label}</div>
                <div className="ShiftTooltipShiftTime">{shiftInfo.timeString}</div>
            </>
        );
    }
    
    return <div className="ShiftTooltipShiftTime">{shiftInfo.timeString}</div>;
};

export default {
    genShiftTooltipLabelAndTime,
};

